import { useState } from 'react';
import { Search, MapPin } from 'lucide-react';
import { Input } from './ui/input';
import { Button } from './ui/button';

export const SearchBar = ({ onSearch, className = '' }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [location, setLocation] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch({ search: searchTerm, location });
  };

  return (
    <form onSubmit={handleSubmit} className={`w-full ${className}`}>
      <div className="flex flex-col sm:flex-row gap-3">
        {/* Search Input */}
        <div className="relative flex-1">
          <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" />
          <Input
            type="text"
            placeholder="Search trainers or specialties..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-12 h-14 bg-[#1A1A1A] border-transparent text-white placeholder:text-gray-500 focus:ring-2 focus:ring-primary focus:border-transparent rounded-xl text-base"
            data-testid="search-input"
          />
        </div>

        {/* Location Input */}
        <div className="relative sm:w-48">
          <MapPin className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" />
          <Input
            type="text"
            placeholder="Location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            className="w-full pl-12 h-14 bg-[#1A1A1A] border-transparent text-white placeholder:text-gray-500 focus:ring-2 focus:ring-primary focus:border-transparent rounded-xl text-base"
            data-testid="location-input"
          />
        </div>

        {/* Search Button */}
        <Button
          type="submit"
          className="h-14 px-8 bg-primary text-white font-bold uppercase tracking-wider rounded-xl hover:shadow-[0_0_30px_rgba(59,130,246,0.6)] transition-all transform hover:-translate-y-0.5 active:scale-95"
          data-testid="search-button"
        >
          Search
        </Button>
      </div>
    </form>
  );
};
